<template>
  <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
    <div class="popup-package popup-coupon-manager-box">
      <div class="popup-content">
        <div class="popup-header popup-coupon-header">
          <h4 class="popup-coupon-title">
            {{ $t('Bao.payment_promo_code_manage') }}
          </h4>
          <a class="popup-close" @click.prevent="hideCoupon">
            <i class="fa-solid fa-xmark" aria-hidden="true" />
          </a>
        </div>

        <div class="popup-body popup-coupon-body">
          <div v-if="coupons.length > 0" class="coupon-section">
            <div class="coupon-section-title">
              {{ $t('Bao.payment_promo_code_available') }}
              <span class="coupon-count">{{ coupons.filter(c => !isIneligible(c)).length }}</span>
            </div>

            <div v-for="coupon in coupons" :key="coupon.id" class="coupon-card">
              <a class="coupon-card-link" href="javascript:;">
                <!--eslint-disable-next-line -->
                <span v-if="coupon.module_name === 'FirstDeposit'" class="coupon-badge coupon-badge-name" @click="goEventPage" v-html="firstDepositText" />
                <p class="coupon-card-code">{{ $t('Bao.payment_promo_code_2') }}：<span>{{ coupon.code }}</span></p>
                <p class="coupon-card-expire">{{ $t('Bao.payment_promo_code_expiry') }}：{{ coupon.end_at | dateFormat }}</p>
              </a>
              <!-- 已完成首存時首存優惠不可報名（與頁面提示卡一致） -->
              <button
                class="coupon-btn coupon-btn-use"
                :disabled="isIneligible(coupon)"
                @click="$emit('applyCoupon', coupon.code)"
              >
                {{ isIneligible(coupon) ? $t('Bao.payment_promo_code_ineligible') : $t('Bao.payment_promo_code_sign') }}
              </button>
            </div>
          </div>

          <div v-if="registeredCoupons.length > 0" class="coupon-section">
            <div class="coupon-section-title">
              {{ $t('Bao.payment_promo_code_registered_2') }}
              <span class="coupon-count">{{ registeredCoupons.length }}</span>
            </div>

            <div v-for="(registered, index) in registeredCoupons" :key="index" class="coupon-card coupon-card-used">
              <a class="coupon-card-link" href="javascript:;">
                <!--eslint-disable-next-line -->
                <span v-if="registered.type === 'first_deposit'" class="coupon-badge coupon-badge-name" @click="goEventPage" v-html="firstDepositText" />
                <p class="coupon-card-code">{{ $t('Bao.payment_promo_code_2') }}：<span>{{ registered.code }}</span></p>
                <p v-if="registered.expire_at" class="coupon-card-expire">{{ $t('Bao.payment_promo_code_expiry') }}：{{ registered.expire_at | dateFormat }}</p>
              </a>
              <button class="coupon-btn coupon-btn-done">
                {{ $t('Bao.payment_promo_code_registered_1') }}
              </button>
            </div>
          </div>

          <div v-if="expiredCoupons.length > 0" class="coupon-section">
            <div class="coupon-section-title">
              {{ $t('Bao.payment_promo_code_ended_2') }}
              <span class="coupon-count">{{ expiredCoupons.length }}</span>
            </div>

            <div v-for="(expired, index) in expiredCoupons" :key="index" class="coupon-card coupon-card-done">
              <a class="coupon-card-link" href="javascript:;">
                <!--eslint-disable-next-line -->
                <span v-if="expired.type === 'first_deposit'" class="coupon-badge coupon-badge-name" @click="goEventPage" v-html="firstDepositText" />
                <p class="coupon-card-code">{{ $t('Bao.payment_promo_code_2') }}：<span>{{ expired.code }}</span></p>
                <p v-if="expired.expire_at" class="coupon-card-expire">{{ $t('Bao.payment_promo_code_expiry') }}：{{ expired.expire_at | dateFormat }}</p>
              </a>
              <button class="coupon-btn coupon-btn-done">
                {{ $t('Bao.payment_promo_code_ended_1') }}
              </button>
            </div>
          </div>
        </div>

        <div class="popup-coupon-footer">
          {{ $t('Bao.payment_promo_code_notice') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DepositCouponModal',
  props: {
    coupons: {
      type: Array,
      default: () => []
    },
    registeredCoupons: {
      type: Array,
      default: () => []
    },
    expiredCoupons: {
      type: Array,
      default: () => []
    },
    firstDepositText: {
      type: String,
      default: ''
    },
    firstDepositUrl: {
      type: String,
      default: ''
    },
    hasFirstDeposit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isIneligible(coupon) {
      return coupon.module_name === 'FirstDeposit' && this.hasFirstDeposit
    },
    hideCoupon() {
      this.$emit('closeCoupon')
    },
    goEventPage() {
      this.$router.push(this.firstDepositUrl)
    }
  }
}
</script>
